import _ from "lodash";
import React, { useState } from "react";

import { CATCH_ALL_INSURANCE_OPTIONS } from "@/core/constants";
import { getCarrierMetadata } from "@/components/Common/InsuranceEligibility/carrierMetadata";

import { AddInsurance } from "../../AddInsurance";
import { InsuranceAcknowledgementPopupHOC } from "../InsuranceAcknowledgementPopupHOC";

export const SelfSignupInsuranceHOC = ({
  closeAcknowledgementHandler,
  firstName,
  formikProps,
  insuranceCompanyOptions,
  isPrimaryInsurance,
  lastName,
  requiredFields,
  showAcknowledgementPopup,
  submitAcknowledgementHandler,
  ...props
}) => {
  const { errors, handleBlur, handleChange, handleFocus, touched, values } = formikProps;
  const { groupIdTooltipContents, memberIdPlaceholder, memberIdTip, memberIdTooltipContents } =
    getCarrierMetadata(values.primary_insurance.carrier);
  const [noInsurance, setNoInsurance] = useState(false);

  const mapDropDownValue = (value) => ({
    label: value,
    value: value,
  });

  const mappedValues = {
    dob: values.dob,
    firstName: values.first_name,
    groupId: values.primary_insurance.group_id,
    insuranceCompany: mapDropDownValue(values.primary_insurance.carrier),
    lastName: values.last_name,
    memberId: values.primary_insurance.member_id,
    policyHolder: values.primary_insurance.policy_holder_question,
  };

  const mappedNames = {
    dob: "dob",
    firstName: "first_name",
    groupId: "primary_insurance.group_id",
    insuranceCompany: "primary_insurance.carrier",
    lastName: "last_name",
    memberId: "primary_insurance.member_id",
    policyHolder: "primary_insurance.policy_holder_question",
    policyHolderName: "primary_insurance.policy_holder_name",
    policyRelationship: "primary_insurance.policy_relationship",
  };

  const mappedTouched = {
    dob: _.get(touched, "dob"),
    firstName: _.get(touched, "first_name"),
    groupId: _.get(touched, "primary_insurance.group_id"),
    insuranceCompany: _.get(touched, "primary_insurance.carrier"),
    lastName: _.get(touched, "last_name"),
    memberId: _.get(touched, "primary_insurance.member_id"),
    policyHolder: _.get(touched, "primary_insurance.policy_holder_question"),
  };

  const mappedErrors = {
    dob: _.get(errors, "dob"),
    firstName: _.get(errors, "first_name"),
    groupId: _.get(errors, "primary_insurance.group_id"),
    insuranceCompany: _.get(errors, "primary_insurance.carrier"),
    lastName: _.get(errors, "last_name"),
    memberId: _.get(errors, "primary_insurance.member_id"),
    policyHolder: _.get(errors, "primary_insurance.policy_holder_question"),
  };

  const generatePolicyHolderName = (e, value) => {
    let policyHolderName = "Other";

    if (value === "yes") {
      policyHolderName = `${firstName} ${lastName}`;
    }
    handleChange({
      ...e,
      target: { ...e.target, name: mappedNames["policyHolderName"], value: policyHolderName },
    });
  };

  const generatePolicyHolderRelationship = (e, value) => {
    let policyHolderRelationship = "Other";

    if (value === "yes") {
      policyHolderRelationship = "self";
    }
    handleChange({
      ...e,
      target: {
        ...e.target,
        name: mappedNames["policyRelationship"],
        value: policyHolderRelationship,
      },
    });
  };

  const mappedChangeHandler = (e) => {
    const { name, value } = e.target;
    const mappedName = mappedNames[name];
    let mappedValue = value;

    switch (name) {
      case "insuranceCompany":
        if (CATCH_ALL_INSURANCE_OPTIONS.includes(value)) {
          formikProps.resetForm();
          setNoInsurance(true);
        } else {
          setNoInsurance(false);
        }
        break;

      case "policyHolder":
        generatePolicyHolderName(e, value);
        generatePolicyHolderRelationship(e, value);
        break;
    }

    handleChange({ ...e, target: { ...e.target, name: mappedName, value: mappedValue } });
  };

  return (
    <>
      <AddInsurance
        errors={mappedErrors}
        groupIdTooltipContents={groupIdTooltipContents}
        handleBlur={handleBlur}
        handleChange={mappedChangeHandler}
        handleFocus={handleFocus}
        hideUploadFile={true}
        insuranceCompanyOptions={insuranceCompanyOptions}
        isPrimaryInsurance={isPrimaryInsurance}
        memberIdPlaceholder={memberIdPlaceholder}
        memberIdTip={memberIdTip}
        memberIdTooltipContents={memberIdTooltipContents}
        noInsurance={noInsurance}
        requiredFields={requiredFields}
        touched={mappedTouched}
        values={mappedValues}
        {...props}
      />

      {showAcknowledgementPopup && (
        <InsuranceAcknowledgementPopupHOC
          acknowledgementType={mappedValues.insuranceCompany.value}
          disabled={!showAcknowledgementPopup}
          gaEventPrefix="digitial-direct"
          primaryOnClick={submitAcknowledgementHandler}
          secondaryOnClick={closeAcknowledgementHandler}
        />
      )}
    </>
  );
};
